import log from 'loglevel'
import {Suspense} from 'react'
import {Outlet} from 'react-router-dom'
import 'react-toastify/dist/ReactToastify.css'
import {LayoutProvider} from '../ui/layout/core'
import {MasterInit} from '../ui/layout/MasterInit'
import {CognitoAuthInit} from './modules/auth'
import {HealthCheckProvider} from '../ui/components/HealthCheckProvider'

export function getLogger() {
  var level = process.env.ENV
  log.setLevel(level === 'PROD' ? log.levels.ERROR : log.levels.DEBUG)
  return log
}

const App = () => {
  return (
    <>
      <Suspense fallback={<div>Loading...</div>}>
        <LayoutProvider>
          <HealthCheckProvider checkInterval={600000} enableNotifications={true}>
            <CognitoAuthInit>
              <Outlet />
              <MasterInit />
            </CognitoAuthInit>
          </HealthCheckProvider>
        </LayoutProvider>
      </Suspense>
    </>
  )
}

export {App}
